import * as React from 'react';


export class PageErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isPageError: false,
    };
  }

  static getDerivedStateFromError(error: any) {
    if ((error.status > 403 && error.status < 600) || !error.status) {
      return {
        isPageError: true,
        message: error.message,
      }
    }
    return {
      isPageError: false,
    }
  }

  render() {
    if (this.state.isPageError) {
      return <div className="flex flex-col items-center justify-center h-screen">
        <div className="flex flex-col items-center justify-center">
          <div className="text-2xl font-bold">Something went wrong :(</div>
          <div className="mt-4">{this.state.message}</div>
        </div>
      </div>;
    }
    return this.props.children;
  }
}

export default PageErrorBoundary;
